import { alpha, AppBar, Box, Button, IconButton, Input, ListItemButton, Paper, styled, Toolbar } from '@mui/material';
import { MAIN_SIZE } from './constants';

// .....................for main .................
export const MainContainer = styled(Box)(({ theme }) => ({
    flex: 1,
    transition: 'all 0.5s ease' /* Adjust the duration and easing as needed */,
    height: '100%',
    boxSizing: 'border-box',

    [theme.breakpoints.down('sm')]: {
        // display: 'none',
    },
}));

// .....................for header .....................
export const HeaderAppBar = styled(AppBar)(({ theme }) => ({
    backgroundColor: theme.palette.background.neutralPrimary,
    color: theme.palette.text.inverse,
    borderBottom: `1px solid ${theme.palette.border.neutralPrimary}`,
    // Fallback for browsers that do not support env()
    paddingTop: 0,
    '@supports (padding: env(safe-area-inset-top))': {
        paddingTop: 'env(safe-area-inset-top)',
    },
}));

export const HeaderToolbar = styled(Toolbar)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    minHeight: MAIN_SIZE.mt,

    paddingLeft:`${theme.typography.generic.xLarge}`,
    paddingRight:`${theme.typography.generic.xLarge}`,

    [theme.breakpoints.up('sm')]: {
        minHeight: MAIN_SIZE.mt,

        paddingLeft:`${theme.typography.generic.xLarge}`,
        paddingRight:`${theme.typography.generic.xLarge}`,
    },
    [theme.breakpoints.up('md')]: {
        minHeight: MAIN_SIZE.mt,
        paddingLeft:`${theme.typography.generic.xLarge}`,
        paddingRight:`${theme.typography.generic.xLarge}`,
    },

    [theme.breakpoints.down('sm')]: {
        minHeight: MAIN_SIZE.mt,
        paddingLeft:`${theme.typography.generic.xLarge}`,
        paddingRight:`${theme.typography.generic.xLarge}`,
    },
}));

export const CenterFlexBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

export const LogoImageBox = styled('div')(({ theme }) => ({
    borderRadius: theme.typography.borderRadius.xSmall,
    border: '1px solid rgba(255, 255, 255, 0.20)',
    cursor: 'pointer',
    padding: '6px',
}));

export const ProfileBox = styled('div')(({ theme }) => ({
    border: '1px solid rgba(255, 255, 255, 0.20)',
    padding: '0.75rem 0.625rem',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    maxHeight: 40,

    fontSize: theme.typography.customFontSize.small,

    marginLeft: theme.typography.generic.xSmall,

    borderRadius: theme.typography.borderRadius.xSmall,
}));

export const SearchInput = styled(Input)(({ theme }) => ({
    marginRight: 1,
    color: theme.palette.text.inverse,

    borderRadius: theme.typography.borderRadius.veryLarge,
    border: '1px solid rgba(255, 255, 255, 0.20)',
    padding: '0.75rem 1rem',

    maxHeight: 45,

    width: '25rem',

    fontFamily: `"Montserrat", sans-serif`,

    fontSize: theme.typography.customFontSize.small,

    fontWeight: 400,
}));

// Notifications
export const NotificationsIconBtn = styled(IconButton)(({ theme }) => ({}));

// nav ..................

export const NavPaper = styled(Paper)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',

    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.typography.borderRadius.none,

    boxShadow: 'unset',

    transition: 'all 0.5s ease' /* Adjust the duration and easing as needed */,

    padding: `${theme.typography.generic.none} ${theme.typography.generic.xSmall}`,

    //

    position: 'fixed',
    // Fallback for browsers that do not support env()
    top: MAIN_SIZE.mt,
    '@supports (top: env(safe-area-inset-top))': {
        top: `calc(${MAIN_SIZE.mt} + env(safe-area-inset-top))`,
    },
    left: '0',
    bottom: '0',
    zIndex: 1,

    [theme.breakpoints.down('sm')]: {
        display: 'none',
    },
}));

export const AccountButton = styled(Button)(({ theme }) => ({
    border: '1px solid rgba(0, 0, 0, 0.08)',

    borderRadius: theme.typography.borderRadius.xxxLarge,

    padding: '0.5rem 0.875rem',

    textTransform: 'unset',

    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    color: theme.palette.text.primary,

    '&:hover': {
        backgroundColor: theme.palette.black[100],
    },
}));

export const AccountName = styled('span')(({ theme }) => ({
    fontSize: theme.typography.customFontSize.small,

    marginLeft: theme.typography.generic.xSmall,
    fontWeight: theme.typography.fontWeightSemiBold,
}));

export const AccountBox = styled('div')(({ theme, showSmallSizeMenu }) => ({
    display: 'flex',
    justifyContent: showSmallSizeMenu ? 'center' : 'space-between',
    alignItems: 'center',
    margin: `${theme.typography.generic.xLarge} ${theme.typography.generic.none}`,
}));


export const NavBottomButton = styled(Button)(({ theme, showSmallSizeMenu, selected }) => ({
    borderRadius: theme.typography.borderRadius.xLarge,
    fontWeight: theme.typography.fontWeightSemiBold,
    fontSize: theme.typography.generic.large,

    padding: '0.5rem 1rem',
    textTransform: 'unset',

    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',

    minWidth: 'unset',
    color: theme.palette.text.secondary,

    marginTop: '0.5rem',

    ...(showSmallSizeMenu && {
        paddingLeft: theme.typography.generic.xSmall,
        paddingRight: theme.typography.generic.xSmall,

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        '& .MuiButton-startIcon': {
            margin: theme.typography.generic.none,
        },
    }),

    '&:hover': {
        backgroundColor: theme.palette.black[200],
    },
    
    ...(selected && {
        backgroundColor: theme.palette.black[200],
    }),
}));

export const MenuBox = styled('div')(({ theme }) => ({
    padding: `${theme.typography.generic.xxxLarge} ${theme.typography.generic.none}`,

    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',

    height: '100%',
}));

// ...............NavItem ..............

export const MenuIconBox = styled('span')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    marginLeft: theme.typography.generic.xSmall,
    marginRight: theme.typography.generic.xSmall,
    color:theme.palette.icon.brandPrimary,

    
    '& svg': {
        fontSize: theme.typography.customFontSize.xLarge,
    },
}));

export const CustomListItemButton = styled(ListItemButton)(({ theme, collapse }) => ({
    minHeight: '2.75rem',

    fontSize: theme.typography.customFontSize.small,

    textTransform: 'capitalize',
    fontWeight: collapse ? theme.typography.fontWeightRegular : theme.typography.fontWeightSemiBold,
    paddingRight: '0.5rem',
    overflow: 'hidden',

    paddingLeft: collapse ? '3rem' : '0.5rem',
    color: collapse ? alpha(theme.palette.text.primary, 0.6) : theme.palette.text.primary,
    marginTop: collapse ? theme.typography.generic.xxxxSmall : '0',

    '& .icon': {
        // opacity: '50%',
    },

    '& .MuiTouchRipple-root': {
        color: alpha(theme.palette.primary.main, 0.5),
    },

    '&:hover': {
        borderRadius: theme.typography.borderRadius.xxxSmall,
        backgroundColor: theme.palette.background.neutralSecondary,
    },

    '&.Mui-selected': {
        fontWeight: theme.typography.fontWeightBold,
        border: `2px solid ${alpha('#000', 0.1)}`,

        borderRadius: theme.typography.borderRadius.xxxSmall,

        backgroundColor: theme.palette.background.neutralSecondary,

        color: theme.palette.text.primary,

        '& .icon': {
            // opacity: '100%',
            // color: theme.palette.primary.main,
        },

        '&:hover': {
            backgroundColor: theme.palette.background.neutralSecondary,
        },
    },

    '&.showSmall': {
        width: 'fit-content',
    },
}));
